// extracted by mini-css-extract-plugin
export default {"tooltipWrap":"tooltipWrap___GWrQv","forceShow":"forceShow___R6h58","img":"img___NVWot","text":"text___Xs6A7","mainText":"mainText___Knsgq","icon":"icon___rP4ms"};